'use client';
import React from 'react';
import Image from 'next/image';
import SliceZone from '@/components/SliceZone';

export default function MicrositeAddToCart({ block, position }) {
  const { image, product_detail_blocks, uid, background_color_picker } =
    block.microsite_add_to_cart.reference[0];
  const backgroundColor = background_color_picker;

  return (
    <section
      id={uid + '_' + position}
      data-name="microsite-add-to-cart"
      className={`bg-[${backgroundColor}] scroll-mt-16 lg:mx-5 lg:my-5 lg:flex lg:justify-center`}
    >
      <div className="flex max-w-[1418px] px-5 py-15 md:px-10 md:py-15 lg:w-full lg:flex-row lg:items-stretch lg:p-10">
        <div className="relative hidden min-h-[300px] overflow-hidden md:hidden lg:flex lg:basis-[60%] lg:items-stretch lg:justify-center">
          <div className="relative h-full min-h-[426px] w-full">
            <Image
              src={image.url}
              alt={image.title.replace(/\.[^/.]+$/, '')}
              fill
              className="object-cover"
              sizes="(min-width: 1024px) 60vw, 100vw"
            />
          </div>
        </div>

        <div className="align-self-stretch w-full min-w-0 md:min-w-[361px] lg:basis-[40%] lg:pl-10">
          <SliceZone blocks={product_detail_blocks} />
        </div>
      </div>
    </section>
  );
}
